import React from 'react'
import { Form, Header } from 'semantic-ui-react'
import { DollarInput } from '../../components/DollarInput'
import { DollarBlurEvent } from '../../components/DollarInput/DollarInput'
import { helpText } from './constants'
import { getError } from './helpers'
import styles from './styles.module.less'
import { TradeFormErrors, TradeFormTouched, TradeFormValues } from './Types'

export interface FeesProps {
  errors: TradeFormErrors
  onFeeBlur: (field: string) => void
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  touched: TradeFormTouched
  values: TradeFormValues
}

const Fees = ({ onFeeBlur, setFieldValue, values, errors, touched }: FeesProps) => {
  const handleFeeBlur = ({ target: { name } }: DollarBlurEvent) => onFeeBlur(name)

  return (
    <section className={`trade-fees ${styles.tradeFees}`}>
      <Header as={'h2'}>Fees</Header>
      <Form>
        <Form.Group widths="equal">
          <Form.Field>
            <DollarInput
              className="commission"
              currency={values.currency}
              error={getError('commission', errors, touched)}
              helpText={helpText.commission}
              label="Commission"
              name="commission"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.commission}
            />
          </Form.Field>
          <Form.Field>
            <DollarInput
              className="mark-up-mark-down"
              currency={values.currency}
              error={getError('markUpMarkDown', errors, touched)}
              helpText={helpText.markUpMarkDown}
              label="Mark-Up / Mark-Down"
              name="markUpMarkDown"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.markUpMarkDown}
            />
          </Form.Field>
          <Form.Field>
            <DollarInput
              className="client-clearing-fee"
              currency={values.currency}
              error={getError('clientClearingFee', errors, touched)}
              label="Client Clearing Fee"
              name="clientClearingFee"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.clientClearingFee}
            />
          </Form.Field>
          <Form.Field>
            <DollarInput
              className="general-purpose-fee"
              currency={values.currency}
              error={getError('generalPurposeFee', errors, touched)}
              label="General Purpose Fee"
              name="generalPurposeFee"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.generalPurposeFee}
            />
          </Form.Field>
          <Form.Field>
            <DollarInput
              className="liquidity-fee"
              currency={values.currency}
              error={getError('liquidityFee', errors, touched)}
              label="Liquidity Fee"
              name="liquidityFee"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.liquidityFee}
            />
          </Form.Field>
          <Form.Field>
            <DollarInput
              className="trade-activity-fee"
              currency={values.currency}
              error={getError('tradeActivityFee', errors, touched)}
              label="Trade Activity Fee"
              name="tradeActivityFee"
              onBlur={handleFeeBlur}
              onChange={setFieldValue}
              value={values.tradeActivityFee}
            />
          </Form.Field>
        </Form.Group>
      </Form>
    </section>
  )
}

export default Fees
